interface LoadingScreenProps {
  text?: string;
}

/**
 * LoadingScreen - Full-screen loading component with logo and pulse animation
 * Used for initial app loading and auth checks
 */
export function LoadingScreen({ text = 'Wird geladen...' }: LoadingScreenProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#1D3541] to-[#0F1C22]">
      <div className="flex flex-col items-center">
        {/* Logo - white version using brightness filter */}
        <img
          src="https://parentpath.de/pp_logo-piktogram-w100.svg"
          alt="ParentPath"
          className="w-20 h-20 mb-8 brightness-0 invert"
        />

        {/* Pulse Animation - Three dots */}
        <div className="flex items-center gap-2 mb-4">
          <span
            className="w-3 h-3 bg-white/80 rounded-full animate-pulse-dot"
            style={{ animationDelay: '0ms' }}
          />
          <span
            className="w-3 h-3 bg-white/80 rounded-full animate-pulse-dot"
            style={{ animationDelay: '150ms' }}
          />
          <span
            className="w-3 h-3 bg-white/80 rounded-full animate-pulse-dot"
            style={{ animationDelay: '300ms' }}
          />
        </div>

        {/* Loading Text */}
        <p className="text-white/70 text-sm">{text}</p>
      </div>
    </div>
  );
}
